/**
 * Mostly GENERATED by scripts/extract-assets.py — regenerate after changing
 * a sheet or the mapping in that script.
 *
 * Exception: the three `building-*-depot`/`building-*-vault`/`building-*-tank`
 * entries (titan-depot, silicate-vault, isotope-tank) are hand-added — the
 * storage buildings were never part of the original 9-tile sheet grid, their
 * art arrived later as individual renders (2026-07-31). A future regeneration
 * from an updated sheet would need these re-added by hand again.
 *
 * Same exception for `building-casino`/`building-shipyard`/
 * `building-ship-hangar` (2026-08-01) — the Casino, Werft and
 * Schiffshangar buildings didn't exist when the sheet was cut either.
 */

import building_casino from './sprites/building-casino.webp';
import building_isotope_condenser from './sprites/building-isotope-condenser.webp';
import building_isotope_tank from './sprites/building-isotope-tank.webp';
import building_missile_silo from './sprites/building-missile-silo.webp';
import building_nano_factory from './sprites/building-nano-factory.webp';
import building_phalanx from './sprites/building-phalanx.webp';
import building_research_lab from './sprites/building-research-lab.webp';
import building_ship_hangar from './sprites/building-ship-hangar.webp';
import building_shipyard from './sprites/building-shipyard.webp';
import building_silicate_refinery from './sprites/building-silicate-refinery.webp';
import building_silicate_vault from './sprites/building-silicate-vault.webp';
import building_solar_plant from './sprites/building-solar-plant.webp';
import building_titan_depot from './sprites/building-titan-depot.webp';
import building_titan_smelter from './sprites/building-titan-smelter.webp';
import building_trade_relay from './sprites/building-trade-relay.webp';
import defense_gauss from './sprites/defense-gauss.webp';
import defense_interceptor from './sprites/defense-interceptor.webp';
import defense_plasma from './sprites/defense-plasma.webp';
import defense_shield_dome from './sprites/defense-shield-dome.webp';
import res_aether from './sprites/res-aether.webp';
import res_chronos from './sprites/res-chronos.webp';
import res_credit from './sprites/res-credit.webp';
import res_isotope from './sprites/res-isotope.webp';
import res_power from './sprites/res-power.webp';
import res_silicate from './sprites/res-silicate.webp';
import res_titan from './sprites/res-titan.webp';
import ship_battleship from './sprites/ship-battleship.webp';
import ship_corvette from './sprites/ship-corvette.webp';
import ship_cruiser from './sprites/ship-cruiser.webp';
import ship_miner from './sprites/ship-miner.webp';
import ship_moon_breaker from './sprites/ship-moon-breaker.webp';
import ship_probe from './sprites/ship-probe.webp';
import ship_transporter from './sprites/ship-transporter.webp';
import ship_void_phantom from './sprites/ship-void-phantom.webp';
import tech_astrometrics from './sprites/tech-astrometrics.webp';
import tech_graviton from './sprites/tech-graviton.webp';
import tech_impulse from './sprites/tech-impulse.webp';
import tech_logistics from './sprites/tech-logistics.webp';
import tech_mining from './sprites/tech-mining.webp';
import tech_shield from './sprites/tech-shield.webp';
import tech_warp from './sprites/tech-warp.webp';

export const SPRITES: Partial<Record<string, string>> = {
  'building-casino': building_casino,
  'building-isotope-condenser': building_isotope_condenser,
  'building-isotope-tank': building_isotope_tank,
  'building-missile-silo': building_missile_silo,
  'building-nano-factory': building_nano_factory,
  'building-phalanx': building_phalanx,
  'building-research-lab': building_research_lab,
  'building-ship-hangar': building_ship_hangar,
  'building-shipyard': building_shipyard,
  'building-silicate-refinery': building_silicate_refinery,
  'building-silicate-vault': building_silicate_vault,
  'building-solar-plant': building_solar_plant,
  'building-titan-depot': building_titan_depot,
  'building-titan-smelter': building_titan_smelter,
  'building-trade-relay': building_trade_relay,
  'defense-gauss': defense_gauss,
  'defense-interceptor': defense_interceptor,
  'defense-plasma': defense_plasma,
  'defense-shield-dome': defense_shield_dome,
  'res-aether': res_aether,
  'res-chronos': res_chronos,
  'res-credit': res_credit,
  'res-isotope': res_isotope,
  'res-power': res_power,
  'res-silicate': res_silicate,
  'res-titan': res_titan,
  'ship-battleship': ship_battleship,
  'ship-corvette': ship_corvette,
  'ship-cruiser': ship_cruiser,
  'ship-miner': ship_miner,
  'ship-moon-breaker': ship_moon_breaker,
  'ship-probe': ship_probe,
  'ship-transporter': ship_transporter,
  'ship-void-phantom': ship_void_phantom,
  'tech-astrometrics': tech_astrometrics,
  'tech-graviton': tech_graviton,
  'tech-impulse': tech_impulse,
  'tech-logistics': tech_logistics,
  'tech-mining': tech_mining,
  'tech-shield': tech_shield,
  'tech-warp': tech_warp,
};

/** Resolve a sprite URL, or undefined when the art has not landed yet. */
export function spriteUrl(id: string): string | undefined {
  return SPRITES[id];
}
